import { createSelector } from '@ngrx/store';

import type { ClipboardState, NdtFileManagerState } from '@app/store/reducers';
import { getFileManagerState } from '@app/store/reducers';

/**
 * General Clipboard State selector
 */
export const getClipboardState: any = createSelector(
  getFileManagerState,
  (state: NdtFileManagerState) => !!state && state.clipboard,
);

export const getClipboardValue: any = createSelector(
  getClipboardState,
  (state: ClipboardState) => !!state && state.value,
);
